import { Status } from 'shared/ui'
import { getNpsGroupByScore } from 'entities/Surveys/lib/getNpsGroupByScore'
import { npsGroupIntents } from './config'
import styles from './styles.module.scss'

type INpsScoreBadgeProps = {
  score: number
}

export const NpsScoreBadge = ({ score }: INpsScoreBadgeProps) => (
  <Status
    title={String(score)}
    intent={npsGroupIntents[getNpsGroupByScore(score)]}
    emphasis='high'
    className={styles.badge}
    typographyProps={{ className: styles.text, ariaLabel: 'NpsScoreBadge_title' }}
    ariaLabel={'NpsScoreBadge'}
  />
)
